import SaaConsumeSurvey from "components/pages/saa/consume/Survey";
import { GetServerSidePropsContext } from "next";
import { NextPage } from "next";
import { getServerSession } from "next-auth";
import { authOptions } from "pages/api/auth/[...nextauth]";

interface Props {
  isMobile: boolean;
  surveyList: any;
}

const SaaConsumeSurveyPage: NextPage<Props> = ({ isMobile, surveyList }) => {
  return <SaaConsumeSurvey isMobile={isMobile} surveyList={surveyList} />;
};
export default SaaConsumeSurveyPage;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { locale } = context;

  // 포트폴리오 있는 회원일 경우 메인 화면으로 redirect
  const session: any = await getServerSession(
    context.req,
    context.res,
    authOptions
  );

  // Todo : 포트폴리오 survey 결과 있는 경우 result 페이지로 이동
  const isExistSurveyResult = await fetch(
    `${process.env.NEXTAUTH_URL}/api/saa/survey?email=${session?.user?.email}&type=consume`
  );
  const isExistSurveyResultJSON = await isExistSurveyResult.json();
  const surveyList = isExistSurveyResultJSON?.surveyList;

  return {
    props: {
      surveyList,
    },
  };
}
